export enum UserRole {
  ADMIN = 'admin',
  OWNER = 'owner',
  MANAGER = 'manager',
  USER = 'user'
}

export interface User {
  _id?: string;
  first_name: string;
  last_name: string;
  email: string;
  role: UserRole;
  password?: string;
  user_created_at?: Date;
  user_updated_at?: Date;
}

export type UserSignUpDto = Pick<User, 'first_name' | 'last_name' | 'email' | 'password'>;

export type UserLoginDto = Pick<User, 'email' | 'password'>;
